import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M2 21V3h20v8.865a7.45 7.45 0 0 0-2-.715V5H4v14h7.016c.046.697.187 1.368.41 2H2Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M7 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM10 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13 18.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0Zm5.5-.888L16.888 16l-.888.888 1.612 1.612L16 20.112l.888.888 1.612-1.613L20.112 21l.888-.888-1.613-1.612L21 16.888 20.112 16 18.5 17.612Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }